export const linkButtonClasses =
    'font-semibold text-textPrimary text-[14px] underline cursor-pointer leading-input focus:ring-0 focus:outline-none';
